// import { formatDate } from '../helpers';
const initialState = {
  activeTab: 'Q&A',
  questions: [],
  polls: [],
  answered: []
}

const parseInitalData = (state, action) => {
  let questions = []
  let polls = []
  let answered = []
  action.payload.comments.forEach(c => {
    if (c.type === 'poll') {
      polls.push(c)
    } else if (c.type === 'q&a') {
      questions.push(c)
    } else if (c.type === 'answer') {
      answered.push(c)
    }
  })
  questions.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  polls.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  answered.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  return {
    questions: questions,
    polls: polls,
    answered: answered
  }
}

const applyComment = (state, action) => {
  let questions = state.questions.slice(0)
  let polls = state.polls.slice(0)
  let answered = state.answered.slice(0)
  if (action.payload.payload.type === 'q&a') {
    questions.push(action.payload.payload)
  } else {
    polls.push(action.payload.payload)
  }
  return {
    questions: questions,
    polls: polls,
    answered: answered
  }
}

const removeLike = (question, like) => {
  question.likes.forEach((l, key) => {
    if (l.participant === like.participant) {
      question.likes.splice(key, 1)
    }
  })
  return question
}

const addRemoveLike = (state, action) => {
  let questions = state.questions.slice(0)
  let polls = state.polls.slice(0)
  let answered = state.answered.slice(0)
  questions.forEach((q, key) => {
    if (q._id === action.payload.payload.comment) {
      if (action.payload.payload.unliked) {
        q = removeLike(q, action.payload.payload)
      } else {
        if (!q.likes) q.likes = []
        q.likes.push(action.payload.payload)
      }
    }
  })
  polls.forEach((q, key) => {
    if (q._id === action.payload.payload.comment) {
      if (action.payload.payload.unliked) {
        q = removeLike(q, action.payload.payload)
      } else {
        if (!q.likes) q.likes = []
        q.likes.push(action.payload.payload)
      }
    }
  })
  answered.forEach((q, key) => {
    if (q._id === action.payload.payload.comment) {
      if (action.payload.payload.unliked) {
        q = removeLike(q, action.payload.payload)
      } else {
        if (!q.likes) q.likes = []
        q.likes.push(action.payload.payload)
      }
    }
  })
  questions.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  polls.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  answered.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  return {
    questions: questions,
    polls: polls,
    answered: answered
  }
}

const replaceEditedComment = (state, action) => {
  if (action.payload.type === 'poll') {
    let polls = state.polls.slice(0)
    let index = polls.findIndex(p => p._id === action.payload._id)
    polls[index] = action.payload
    return { ...state, polls }
  }

  let questions = state.questions.slice(0)
  questions.forEach(q => {
    if (q._id === action.payload._id) {
      q.text = action.payload.text
    }
  })
  return { ...state, questions }
}

const applyChanges = (state, action) => {
  let questions = state.questions.slice(0)
  let answered = state.answered.slice(0)

  const qIndex = questions.findIndex(q => q._id === action.payload._id)
  const aIndex = answered.findIndex(a => a._id === action.payload._id)

  if (qIndex > -1) {
    questions.splice(qIndex, 1)
    answered.push(action.payload)
  }

  if (aIndex > -1) {
    answered[aIndex] = action.payload
  }

  questions.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  answered.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })

  return {
    questions: questions,
    answered: answered
  }
}

const editAnsweredText = (state, action) => {
  let answered = state.answered.slice(0)

  answered.forEach(a => {
    if (a._id === action.payload._id) {
      const index = a.answer.findIndex(ans => ans._id === action.payload.answer._id)
      a.answer[index].text = action.payload.answer.text
    }
  })

  answered.sort((a, b) => {
    let aNumber = 0
    let bNumber = 0
    if (a.likes !== null) aNumber = a.likes.length
    if (b.likes !== null) bNumber = b.likes.length
    return bNumber - aNumber
  })
  return {
    answered: answered
  }
}

const comments = (state = initialState, action) => {
  switch (action.type) {
    case 'socket/ANSWERED_COMMENT':
      return {
        ...state,
        ...applyChanges(Object.assign({}, state), action.payload)
      }
    case 'socket/EDIT_ANSWERED_COMMENT':
      return {
        ...state,
        ...editAnsweredText(Object.assign({}, state), action.payload)
      }
    case 'comments/activeTab':
      return {
        ...state,
        activeTab: action.tab
      }
    case 'socket/ADD_NEW_QAPOLLS':
      return {
        ...state,
        ...applyComment(Object.assign({}, state), action)
      }
    case 'socket/LIKE_COMMENT':
      return {
        ...state,
        ...addRemoveLike(Object.assign({}, state), action)
      }
    case 'socket/INIT_DATA':
      return {
        ...state,
        ...parseInitalData(Object.assign({}, state), action)
      }
    case 'socket/UPDATED_COMMENT':
      return {
        ...state,
        ...replaceEditedComment(Object.assign({}, state), action.payload)
      }
    default:
      return state
  }
}

export default comments



// WEBPACK FOOTER //
// ./src/reducers/comments.js